export default "<ion-slide>\r\n  <h1>veneco</h1>\r\n</ion-slide>\r\n";